import { useQuery } from "react-query";
import { getAssessments, getStudentMyAssessments } from "../services/school/assessment/getAssessments";
import { PagedRequestType } from "../types/PagedResults";
import { key_assessments, key_assessments_student } from "../utils/constants";

export const useGetAssessmentsQuery = (data: PagedRequestType, options:any=null) =>
  useQuery(
    [key_assessments, JSON.stringify(data)],
    () => getAssessments(data),
    options?{...options}:{}

  );
export const useGetStudentMyAssessmentsQuery = (data: PagedRequestType, options:any=null) =>
  useQuery(
    [key_assessments_student, JSON.stringify(data)],
    () => getStudentMyAssessments(data),
    options?{...options}:{}

  );